import { Component, inject, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';
// import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
    selector: 'app-captcha-modal',
    imports: [RecaptchaModule, FormsModule],
    templateUrl: './captcha-modal.component.html',
    styleUrl: './captcha-modal.component.scss'
})
export class CaptchaModalComponent {
    recaptchaService = inject(RecaptchaService);
    activeModal = inject(NgbActiveModal);

    isResolved: boolean = false;
    resolved = output<void>();

    resolveCaptcha(captchaResponse: string) {
        this.isResolved = true;
        this.recaptchaService.currentV2Token.set(captchaResponse);
        this.resolved.emit();
        setTimeout(() => {
            this.activeModal.close();
        }, 400);
    }

    rejectCaptcha(error) {
        console.log('error in captcha modal', error);
    }

    canExit() {
        return this.isResolved;
    }
}
